<template>
  <div class='main'>
    <div class="main_left_box1_top">
      <el-cascader
        style="margin-left:10px"
        :options="experTreeList"
        @change="setIdChange"
        clearable
        placeholder="请选择实验"
        :props="{ expandTrigger: 'hover',label:'itemname',value:'itemid',emitPath:false }"
        :show-all-levels="false"
      ></el-cascader>
    </div>
    <div class="main_left_box1_body">
      <el-table
        :data="setTableData"
        stripe
        empty-text="请选择实验"
        style="width: 100%"
      >
        <el-table-column
          type="index"
          label="序号"
          width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="itemname"
          label="步骤名称"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="allcount"
          label="操作次数"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="maxtime"
          label="最高时长"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="mintime"
          label="最低时长"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="avgtime"
          label="平均时长"
          align="center"
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import Api from '../../api/index'

export default {
  data () {
    return {
      experTreeList: [],
      setTableData: [],
      experimentid: ''
    }
  },
  created () {
    this.GetExperTree()
    this.GetStepSumData()
  },
  methods: {
    //获取实验树形结构
    async GetExperTree () {
      const res = await Api.sum.GetExperTree()
      this.experTreeList = res.rows
    },
    //根据实验id筛选实验步骤
    setIdChange (e) {
      this.experimentid = e
      this.GetStepSumData()
    },
    //获取实验步骤情况
    async GetStepSumData () {
      const res = await Api.sum.GetStepSumData(this.experimentid)
      this.setTableData = res.rows
      console.log(res);
    },
  }
}
</script>
<style lang='less' scoped>
.main {
  width: 100%;
  height: 100%;
  background: #fff;
  .main_left_box1_top {
    padding: 15px;
  }
}
</style>